import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { FsRuleTemplate } from './rule-template';

export class FsRule extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  public template: FsRuleTemplate;

  @Expose()
  public fields: any;

  @Expose()
  public lockTime: number;

  @Expose()
  public notificationGroups: any[];

  @Expose()
  public notificationUsers: any[];

  @Expose()
  public notificationChatchannels: any[];

  @Expose()
  public isEnabled: boolean;

  @Expose()
  public schedules: any[];

  @Expose()
  public timezone: string;

  @Expose()
  public isSystemRule: boolean;

  @Expose()
  public isDynamic: boolean;

  @Expose()
  public createdBy: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
